import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ConsultaAPI } from "../../../../../shared/http-requests";
import DropDownSearch, { makeDataSource } from "./DropDownSearch";

/**
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param setDisciplina {function}
 * @returns {JSX.Element}
 * @constructor
 */
const DropDownInputDisciplinas = ( {setDisciplina, codDepartamento} ) => {
    const [data, setData] = useState()
    const [pagination, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [selected, setSelected] = useState(0);

    /**
     * Busca o dado pelo id caso seja um acesso direto pela url
     */
    useEffect(() => {
        const disciplina  = params.get('disciplina');

        if(disciplina){
            ConsultaAPI.buscarDisciplinaPorCodigo(disciplina).then((response) => {
                const { data } = response;
                if(data){

                    const config = {
                        key: 'cod_disciplina',
                        text: ({cod_disciplina, descricao}) => {
                            return `${cod_disciplina} - ${descricao}`
                        },
                        id: 'cod_disciplina',
                        textToFind: 'descricao'
                    }

                    const parsedData = makeDataSource([data], config);
                    setDisciplina(parsedData[0])
                    setSelected(data?.cod_disciplina)
                    setData(parsedData);
                }
            }).catch((error) => {
                // console.log(error)
            })
        }
    }, []);


    const buscarDisciplinas = (text = '', page= 1) => {
        setLoading(true)
        return  ConsultaAPI.buscarDisciplinas(text, codDepartamento,  page).then((response) => {

            const { data } = response;
            if(data){
                const { results, totalPages, currentPage } = data
                setPagination({totalPages, currentPage})

                setData(makeDataSource(results, {
                    key: 'cod_disciplina',
                    text: ({cod_disciplina, descricao}) => {
                        return `${cod_disciplina} - ${descricao}`
                    },
                    id: 'cod_disciplina',
                    textToFind: 'descricao'
                }))

                setLoading(false)
            }
        }).catch((error) => {
            setLoading(false)
            // console.log(error)
        })
    }

    return (
        <DropDownSearch
            placeholder="Selecione uma disciplina"
            customFilter
            loading={loading}
            value={selected}
            data={data}
            onChange={buscarDisciplinas}
            onSelect={(item) => {
                setDisciplina(item);
            }}
            pagination={pagination}
        />
    )
}

export default DropDownInputDisciplinas;
